<template>
	<v-dialog
		v-model="open"
		fullscreen
		persistent
		transition="dialog-bottom-transition"
		style="overflow-x: hidden"
		scrollable>
		<v-card class="background-1 rounded-0" v-if="open">
			<v-card-title class="pa-3">
				<p class="pl-2 pl-xl-3">Importa Esiti Bancari</p>
				<v-spacer></v-spacer>
				<v-btn icon @click.native.stop="close()"><v-icon>mdi-close</v-icon></v-btn>
			</v-card-title>
			<v-divider></v-divider>

			<v-card-text style="overflow-x: hidden" class="pa-0">
				<v-container class="px-6" fluid>
					<v-card class="round-card background-2 pa-6 mt-6">
						<v-row class="ma-0">
							<v-col cols="12" md="5" class="pa-2">
								<v-file-input
									v-model="file"
									label="File di esito (pain.002, camt.054 o CBI RIBA)"
									prepend-icon="mdi-file-import-outline"
									outlined
									dense
									hide-details="auto"
									:disabled="!loaded"
									@change="uploadFile"
								></v-file-input>
							</v-col>
						</v-row>
						<fields-generator
							v-if="loaded"
							:fieldsset.sync="infoFieldsset"
							:model.sync="filters"
							ref="fieldsgenerator"
						></fields-generator>
						<v-row class="ma-0 pt-4" v-if="format">
							<small>Formato riconosciuto: <strong>{{ format }}</strong></small>
						</v-row>
					</v-card>
				</v-container>

				<v-container class="px-6" fluid v-if="matched.length || unmatched.length">
					<v-row class="mx-0">
						<v-col cols="12" class="display-flex px-1 pt-6 pb-0">
							<strong>Esiti abbinati</strong>
							<span class="grey--text pr-4">&nbsp;({{ matched.length }})</span>
							<strong>Da gestire a mano</strong>
							<span class="grey--text pr-4">&nbsp;({{ unmatched.length }})</span>
						</v-col>
					</v-row>

					<v-card class="round-card background-2 pa-4 mt-4" v-if="matched.length">
						<v-simple-table class="background-2" dense>
							<template v-slot:default>
								<thead>
									<tr>
										<th>Scadenza</th>
										<th>Azienda</th>
										<th class="text-right">Importo Scadenza</th>
										<th class="text-right">Importo File</th>
										<th>Esito</th>
										<th>Motivo</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(row, i) in matched" :key="'m' + i">
										<td>{{ row.name }}</td>
										<td>{{ row.business_name }}</td>
										<td class="text-right">{{ row.amount | currency(2) }}</td>
										<td class="text-right">{{ row.file_amount !== null && row.file_amount !== undefined ? $options.filters.currency(row.file_amount, 2) : '-' }}</td>
										<td>
											<v-chip small :color="row.outcome === 1 ? 'success' : 'error'" dark>
												{{ row.outcome === 1 ? 'Positivo' : 'Negativo' }}
											</v-chip>
										</td>
										<td>{{ row.reason }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-card>

					<v-card class="round-card background-2 pa-4 mt-4" v-if="unmatched.length">
						<v-alert type="warning" text class="mb-2">Queste righe non sono state abbinate e non verranno applicate.</v-alert>
						<v-simple-table class="background-2" dense>
							<template v-slot:default>
								<thead>
									<tr>
										<th>Riferimento</th>
										<th class="text-right">Importo</th>
										<th>Scadenza</th>
										<th>Motivo</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(row, i) in unmatched" :key="'u' + i">
										<td>{{ row.reference }}</td>
										<td class="text-right">{{ row.amount | currency(2) }}</td>
										<td>{{ row.expiration_date | date }}</td>
										<td>{{ row.message }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-card>
				</v-container>
			</v-card-text>

			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="info" @click.native="close()">Annulla</v-btn>
				<v-btn text color="primary" @click.native="validateFields()" :loading="sending" :disabled="matched.length == 0">Importa</v-btn>
			</v-card-actions>
		</v-card>

		<confirm-dialog
			:confirmModel="confirmImport"
			mainTitle="Confermi l'import di questi esiti?"
			secondTitle="Gli esiti positivi registrano i pagamenti e chiudono le scadenze; i negativi le rendono insolute."
			@update:confirmModel="confirmImport = false"
			:atConfirm="importSettlements"
			:confirm="{color: 'info', label: 'importa'}"
		></confirm-dialog>
	</v-dialog>
</template>

<script>

	export default {
		name: 'import-settlements',
		props: {
			params: Object,
			selected: Array,
			selectedIds: Array,
			modelDef: String,
			open: Boolean,
			button: Object,
		},

		data() {
			return {
				file: null,
				format: null,
				uploadedFile: null,
				uploadedHash: null,
				uploadedMatchHash: null,
				infoFieldsset: [],
				filters: {},
				loaded: false,
				matched: [],
				unmatched: [],
				sending: false,
				confirmImport: false,
			}
		},

		watch: {
			open: {
				handler(newValue) {
					if(newValue) {
						this.getInfo()
					}
				}
			},

			'filters.flow': {
				handler() {
					if(this.file) {
						this.uploadFile()
					}
				}
			},
		},

		methods: {

			getInfo() {
				this.axios.get('settlements-info/').then(response => {
					this.infoFieldsset = response.data.fields

					_.forEach(this.infoFieldsset.fields, (value) => {
						if(value.type === 'checkbox') {
							this.$set(this.filters, value.key, '')
						}
						if(value.default) {
							this.$set(this.filters, value.key, value.default)
						}
					})

					this.loaded = true
				}, () => {})
			},

			uploadFile() {
				if(!this.file) {
					this.resetPreview()
					return
				}

				// Nuovo file al posto di uno scartato o di un'anteprima mai
				// confermata (watcher su filters.flow o scelta di un altro
				// file): il precedente va segnalato al backend perché lo
				// cancelli, altrimenti i cambi ripetuti di flusso accumulano
				// copie orfane in upload/.
				let previousFile = this.uploadedFile

				this.resetPreview()

				let formData = new FormData()
				formData.append('file', this.file)
				formData.append('flow', this.filters.flow)
				if(previousFile) {
					formData.append('previous_file', previousFile)
				}

				this.axios.post('settlements-upload', formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
					this.uploadedFile = response.data.file
					this.uploadedHash = response.data.hash
					this.uploadedMatchHash = response.data.match_hash
					this.format = response.data.format
					this.matched = response.data.matched
					this.unmatched = response.data.unmatched
				}, () => {
					this.resetPreview()
				})
			},

			importSettlements() {
				this.sending = true

				this.axios.post('settlements-import', {
					file: this.uploadedFile,
					hash: this.uploadedHash,
					match_hash: this.uploadedMatchHash,
					flow: this.filters.flow,
					financial_account: this.filters.financial_account,
				}).then(response => {
					this.sending = false
					this.$eventBusUtility.$emit('refreshTable_' + this.modelDef)
					this.$store.commit('setSnackbar', {timeout: 8000, text: response.data.message, value: true, color: response.data.status})
					this.close()
				}, () => {
					this.sending = false
				})
			},

			resetPreview() {
				this.uploadedFile = null
				this.uploadedHash = null
				this.uploadedMatchHash = null
				this.format = null
				this.matched = []
				this.unmatched = []
			},

			close() {
				this.file = null
				this.resetPreview()
				this.confirmImport = false
				this.sending = false
				this.loaded = false
				this.filters = {}
				this.infoFieldsset = []
				this.$emit('close')
			},

			validateFields() {
				this.$refs.fieldsgenerator.$validator.validateAll().then(result => {
					if (!result) {
						return false
					} else {
						this.confirmImport = true
					}
				}).catch(() => {})
			},
		},
	}
</script>
